// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3JSfE","insightsList":"newBusinessInsightsMenu_insightsList__3w4EY","active":"newBusinessInsightsMenu_active__1Bfpt"};